import React, { useState } from "react";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth, db } from "../../firebase";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { useDispatch } from "react-redux";
import { showLoading, hideLoading } from "../../../redux/actions/loadingActions";
import { getUserRole } from "../../utils/getUserRole";
import { setUserRole } from "../../../redux/actions/authActions";
import { mostrarAviso, mostrarError, mostrarInfo } from "../../utils/Alertas";
import TextField from "@mui/material/TextField";

interface Props {
	onSuccess: () => void;
}

const RegisterForm: React.FC<Props> = ({ onSuccess }) => {
	const [nombre, setNombre] = useState("");
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [confirm, setConfirm] = useState("");
    const dispatch = useDispatch();

	const handleRegister = async (e: React.FormEvent) => {
		e.preventDefault();

		if (!nombre.trim() || !email.trim() || !password.trim() || !confirm.trim()) {
            mostrarInfo("Por favor, completa todos los campos.");
            return;
        }

		// Validar formato de email simple
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		if (!emailRegex.test(email)) {
			mostrarError("El correo no tiene un formato válido.");
			return;
		}

		if (password.length < 6) {
			mostrarError("La contraseña debe tener al menos 6 caracteres.");
			return;
		}

		if (password !== confirm) {
			mostrarError("Las contraseñas no coinciden.");
			return;
		}

        dispatch(showLoading());
		try {
			const userCredential = await createUserWithEmailAndPassword(auth, email, password);
			const user = userCredential.user;

			// Guardar datos adicionales en Firestore
			await setDoc(doc(db, "usuarios", user.uid), {
				nombre,
				email: user.email,
				fechaRegistro: serverTimestamp()
			});

            const rol = await getUserRole();
            if (rol) {
                dispatch(setUserRole(rol));
            }

			onSuccess();
		} catch (err: any) {
			switch (err.code) {
				case "auth/email-already-in-use":
					mostrarError("El correo ya está registrado.");
					break;
				case "auth/invalid-email":
					mostrarError("El correo es inválido.");
					break;
				case "auth/weak-password":
					mostrarAviso("La contraseña es demasiado débil.");
					break;
				default:
					mostrarError("Error al registrar el usuario.");
			}
		} finally {
            dispatch(hideLoading());
        }
	};

	return (
		<form onSubmit={handleRegister} className="auth-form">
			<h2>Registro</h2>

            <TextField
                type="text"
                label="Nombre"
                variant="outlined"
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
                fullWidth
                margin="normal"
            />

            <TextField
                type="email"
                label="Correo electrónico"
                variant="outlined"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                fullWidth
                margin="normal"
                style={{ marginTop: "10px" }}
            />

            <TextField
                type="password"
                label="Contraseña"
                variant="outlined"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                fullWidth
                margin="normal"
                style={{ marginTop: "10px" }}
            />

            <TextField
                type="password"
                label="Confirmar contraseña"
                variant="outlined"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                fullWidth
                margin="normal"
                style={{ marginTop: "10px" }}
            />
            
			<button type="submit">Registrarse</button>
		</form>
	);
};

export default RegisterForm;
